import { Layout } from 'components/atoms'
import { InputBuild } from 'components/molecules'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormConsortiumValue } from './form'
import { ViewConsortiumFormProps } from './interfaces'

const ViewConsortiumForm: React.FC = () => {
    const { register, watch } = useFormContext<{
        consortium: ViewConsortiumFormProps
    }>()

    return (
        <Layout
            full
            type="container"
            display="grid"
            gap={8}
            data-testid="form-container"
        >
            <Layout type="row" gutter={{ y: 1.5 }} data-testid="form-fields">
                {FormConsortiumValue.map(({ layout, input }, key) => (
                    <Layout {...layout} key={key}>
                        {input && (
                            <InputBuild
                                {...input}
                                {...register(`consortium.${input.id}`, {
                                    valueAsNumber: input.type === 'number'
                                })}
                                value={
                                    watch(`consortium.${input.id}`) as string
                                }
                                isDisable={true}
                            />
                        )}
                    </Layout>
                ))}
            </Layout>
        </Layout>
    )
}

export default ViewConsortiumForm
